import * as React from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import finance from '../../images/sideBar/coins-stacked.svg';
import dashboard from '../../images/sideBar/home-line.svg';
import { useNavigate, useParams } from 'react-router';
import useAuth from 'src/hooks/useAuth';
import { notifyError } from 'src/utils/toast';
import { httpGet } from 'src/axios/axiosUtils';
import { reducer } from 'src/contexts/Auth/reducer';
import { initialAuthState } from 'src/contexts/Auth';
import { LogoContext, LogoProvider } from 'src/contexts/companiesContext';
import { Typography } from '@mui/material';

interface companiesTypes {
  companyId: number;
  name: string;
  logo: any;
}

export default function DashboardList() {
  const { setLogo } = React.useContext(LogoContext);

  const params = useParams();

  const [openOne, setOpenOne] = React.useState(true);
  const [companies, setCompanies] = React.useState<companiesTypes[]>([]);
  const navigate = useNavigate();
  const auth = useAuth();

  const handleClickOne = () => {
    setOpenOne(!openOne);
  };

  const [loading, setLoading] = React.useState(true);
  const fetchCompanies = async () => {
    try {
      const res =
        auth?.user?.accountType === 'Accelerator'
          ? await httpGet(`/accelerator/company`)
          : await httpGet(`/investor/company`);

      setCompanies(res);
    } catch (error) {
      notifyError(error?.message);
    } finally {
      setLoading(false);
    }
  };
  const { user, setData, compData } = useAuth();

  React.useEffect(() => {
    if (user) {
      fetchCompanies();
    }
  }, []);

  React.useEffect(() => {
    if (companies?.length) {
      setData(companies[0]!!);
      navigate(`/companies/${companies[0]?.companyId}`);
    }
  }, [companies]);

  if (loading) {
    return <></>;
  }
  return (
    <List
      component="nav"
      className="w-full h-1/2"
      sx={{ height: '90%' }}
      aria-labelledby="nested-list-subheader"
    >
      <ListItemButton
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          mb: 1,
          borderRadius: 2
        }}
        onClick={handleClickOne}
      >
        <div className="flex flex-row items-center">
          <img className="mr-2 w-6 h-6" src={finance} />

          <Typography
            fontWeight={'600'}
            color="#344054"
            fontSize={16}
            className="bold  text-lg"
          >
            Companies
          </Typography>
        </div>
        {openOne ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={openOne} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {companies?.map((comp) => (
            <ListItemButton
              key={comp?.companyId}
              sx={{
                borderRadius: 2,
                pl: 6,
                background:
                  compData?.companyId == comp?.companyId
                    ? 'rgba(0, 0, 0, 0.04)'
                    : 'transparent',
                mb: 1,
              }}
              onClick={() => {
                setData(comp!!);
                navigate(`/companies/${comp?.companyId}`);
              }}
            >
              <ListItemText primary={comp?.name} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </List>
  );
}

const Test = (props) => {
  const { logo, setLogo } = React.useContext(LogoContext);

  return <div />;
};
